import { Element, ElementList, ElementsClassificationRequest, FolderTreeNode, SearchElementsRequest } from '@bimdata/definitions/dto';
import api from './api';
import { compressQuery } from '@bimdata/client/utils/compression';

async function classifications(
  project: string,
  options: ElementsClassificationRequest,
  accessToken?: string,
): Promise<FolderTreeNode[]> {
  const { data } = await api.get<Array<FolderTreeNode>>(
    `/project/${project}/element/classification`,
    {
      params: { q: compressQuery(options) },
      accessToken,
    }
  );
  return data;
}

async function elements(project: string, options: SearchElementsRequest, accessToken?: string,): Promise<ElementList> {
  const { data } = await api.get(`/project/${project}/element`, { params: { q: compressQuery(options) }, accessToken });
  return data;
}

async function element(project: string, id: number, accessToken?: string): Promise<Element> {
  const { data } = await api.get(`/project/${project}/element/${id}`, { accessToken });
  return data;
}

export {
  classifications, elements, element
};